module.exports = __webpack_public_path__ + "static/img/close3.ed85f1a4.png";